import {Component, HostListener, OnInit} from '@angular/core';
import {AppService} from '../../../../services/app.service';
import {ActivatedRoute, Route, Router} from '@angular/router';
import * as $ from 'jquery';
import UIkit from 'uikit';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements OnInit {

  constructor(
    public _appService: AppService,
    private _router: Router
  ) {
  }

  ngOnInit(): void {
  }

  //first accordion open
  step = 0;

  setStep(index: number) {
    this.step = index;
  }

  navbarfixed: boolean = true;
  x = window.innerHeight;

  @HostListener('window:scroll', ['$event']) onscroll() {
    console.log(this.x);
    if (window.pageYOffset > this.x) {
      this.navbarfixed = false;
    } else {
      this.navbarfixed = true;
    }
  }

  redirectToPlay(): void {
    // if (this._appService.getAccessToken()) {
      this._router.navigate(['/' + this._appService.getCurrentCity() + '/play-deal-pe-deal/play']);
    // } else {
    //   UIkit.modal('#modal-center').show();
    // }
  }
}
